import { useState } from 'react'
import { accountAPI } from '../services/api'
import { useAuth } from '../context/AuthContext'
import { useNotification } from '../context/NotificationContext'
import { getErrorMessage } from '../utils/helpers'

const Account = () => {
  const { user, updateUsername } = useAuth()
  const { showSuccess, showError } = useNotification()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const formData = new FormData(e.target)
    
    try {
      const data = {
        current_password: formData.get('current_password'),
        new_username: formData.get('new_username'),
        new_password: formData.get('new_password'),
      }

      const response = await accountAPI.update(data)
      
      if (data.new_username && data.new_username !== user.username) {
        updateUsername(data.new_username)
      }
      
      showSuccess((response.data.msg || 'Admin account updated.') + ' Use your updated credentials on all future logins.')
      e.target.reset()
    } catch (error) {
      showError(getErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="admin-page">
      <h2 className="admin-title">Admin Account</h2>
      <p className="admin-sub">Update your admin credentials</p>

      <div className="row">
        <div className="col-lg-6">
          <div className="panel">
            <div className="panel-head">Change Username or Password</div>
            <form onSubmit={handleSubmit}>
              <div className="note">
                <i className="fa fa-info-circle"></i> You must provide your current password to make any changes.
              </div>
              
              <div className="form-group">
                <label>Current Password *</label>
                <input 
                  type="password" 
                  name="current_password" 
                  className="form-control" 
                  required 
                  autoComplete="current-password"
                />
              </div>
              
              <div className="form-group">
                <label>New Username (leave blank to keep current: {user?.username})</label>
                <input 
                  type="text" 
                  name="new_username" 
                  className="form-control" 
                  placeholder={user?.username}
                  autoComplete="username"
                />
              </div>
              
              <div className="form-group">
                <label>New Password (leave blank to keep current)</label>
                <input 
                  type="password" 
                  name="new_password" 
                  className="form-control" 
                  placeholder="Enter new password"
                  autoComplete="new-password"
                />
              </div>
              
              <button 
                type="submit" 
                className="btn btn-gold btn-block"
                disabled={loading}
              >
                {loading ? 'Updating...' : 'Update Account'}
              </button>
            </form>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="panel">
            <div className="panel-head">Account Information</div>
            <div className="mini-stat">
              <span>Current Username</span>
              <strong>{user?.username}</strong>
            </div>
            <p className="muted" style={{marginTop: '1rem'}}>
              Your admin credentials are used to access this admin panel. 
              Keep them secure and update them regularly for security.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Account
